var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 22.834L12 12.8747M17 4.21446C12.6868 1.72425 7.28964 2.81234 4.246 6.55765C3.94893 6.92321 3.80039 7.10599 3.75718 7.36787C3.7228 7.57623 3.77373 7.85236 3.88018 8.03475C4.01398 8.26398 4.25111 8.4009 4.72539 8.67472L19.2746 17.0747C19.7489 17.3485 19.986 17.4854 20.2514 17.4867C20.4626 17.4877 20.7272 17.3937 20.8905 17.2598C21.0957 17.0914 21.1797 16.8714 21.3477 16.4313C23.0695 11.9228 21.3132 6.70468 17 4.21446ZM17 4.21446C15.0868 3.10989 11.2973 6.09179 8.5359 10.8747M17 4.21446C18.9132 5.31903 18.2255 10.0918 15.4641 14.8747M22 22.8747H2",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitality);
export default __webpack_public_path__ + "static/media/hospitality.3496664b27d5da467641700730dde938.svg";
export { ForwardRef as ReactComponent };